import React from "react"
import { Button, ButtonStyle } from "../components/button"
import { ALLOWED_FILE_EXTENSIONS, ALLOWED_FILE_EXTENSIONS_ADDITIONAL, MAX_FILESIZE_BYTES } from "../constants"
import FileInfo, { FilePickerProps } from "../models/fileInfo"

export class FilePicker extends React.Component<FilePickerProps, any> {
    private inputElement?: HTMLInputElement

    componentDidMount() {
        if (this.inputElement) {
            const inputElement = this.inputElement
            inputElement.addEventListener("change", () => {
                if (inputElement.files === null || !inputElement.files[0]) {
                    return
                }

                const file = inputElement.files[0]

                if (file.size > MAX_FILESIZE_BYTES) {
                    this.props.onFileSelected("file-too-big", null, null)
                    return
                }

                if (file.name.split(".").length < 2) {
                    this.props.onFileSelected("unsupported-extension", null, null)
                    return
                }
                const fext = file.name.split(".")[file.name.split(".").length - 1]

                if (
                    ALLOWED_FILE_EXTENSIONS.indexOf(fext.toString().toLowerCase()) < 0 &&
                    ALLOWED_FILE_EXTENSIONS_ADDITIONAL.indexOf(fext.toString().toLowerCase()) < 0
                ) {
                    console.info(fext.toString().toLowerCase())
                    this.props.onFileSelected("unsupported-extension", null, null)
                    return
                }

                //TODO change this for multipart upload
                const reader = new FileReader()
                reader.onload = () => {
                    const filetype = file.type === "text/xml" ? "application/xml" : file.type
                    this.props.onFileSelected(null, file, new FileInfo(file.name, file.size, btoa(reader.result as string), filetype))
                }

                reader.onerror = (error) => {
                    console.log("Error: ", error)
                }

                reader.readAsArrayBuffer(file)
            })
        }
    }

    onButtonClicked = () => {
        if (this.inputElement) {
            this.inputElement.click()
        }
    }

    render() {
        const { t } = this.props
        return (
            <span>
                <Button label={t("general.dateiAuswahl.button.label")} onClick={this.onButtonClicked} style={this.props.style || ButtonStyle.PRIMARY} />
                <input type="file" style={{ display: "none" }} ref={(e) => (this.inputElement = e !== null ? e : undefined)} />
            </span>
        )
    }
}
